/**
 * Created by lihanying on 2017/7/10.
 */
import React from 'react'
import { Table, Button } from 'antd'
import { clickDownload, copyToClip, round } from '../../../util/index'
import ModalRecord from './modalRecord'
import { changeStringTime, changeToDecimal } from '../../../util'

export default class extends React.Component {
  state = {
    visible: false,
  }

  //求和(金额)
  // priceSum=(list)=>{
  //     let sum = 0;
  //     list.map(item=>{
  //         sum += +item.allsales;
  //     });
  //     return sum.toFixed(2);
  // };

  handleCancel = () => {
    this.setState({ visible: false })
  }

  handleMore = (record) => {
    this.setState({ loading: true })
    const { period } = this.props
    this.props
      .fetchMarketRecord({
        start_time: period.start_time,
        end_time: period.end_time,
        id: record.commodity_id,
      })
      .then((res) => {
        this.setState({
          loading: false,
          visible: true,
          record: record,
        })
      })
  }

  render() {
    const { list, marketRecord, period, scaleList, sum } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '商品名称',
        dataIndex: 'commodity_name',
        key: 'commodity_name',
      },
      {
        title: '商品分类',
        dataIndex: 'type_name',
        key: 'type_name',
      },
      {
        title: '零售价',
        dataIndex: 'cprices',
        key: 'cprices',
        sorter: (a, b) => a.cprices - b.cprices,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '累计销量',
        dataIndex: 'num',
        key: 'num',
        sorter: (a, b) => a.num - b.num,
      },
      {
        title: '销售总额',
        dataIndex: 'allsales',
        key: 'allsales',
        sorter: (a, b) => a.allsales - b.allsales,
        render: (text) => {
          return <span>{changeToDecimal(text)}</span>
        },
      },
      {
        title: '销售记录',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <Button type="primary" onClick={() => this.handleMore(record)}>
              查询
            </Button>
          )
        },
      },
    ]
    const columnsScale = [
      { title: 'id', dataIndex: 'id', key: 'id' },
      { title: '商品名称', dataIndex: 'commodity_name', key: 'commodity_name' },
      { title: '商品分类', dataIndex: 'type_name', key: 'type_name' },
      { title: '零售价', dataIndex: 'price_sale', key: 'price_sale' },
      { title: '累计销量', dataIndex: 'qty_sale', key: 'qty_sale' },
      { title: '销售总额', dataIndex: 'amount_sale', key: 'amount_sale' },
      { title: '支付方式', dataIndex: 'payment', key: 'payment' },
      { title: '销售班次', dataIndex: 'employee', key: 'employee' },
      { title: '购买账号', dataIndex: 'account', key: 'account' },
      { title: '用户名称', dataIndex: 'nickname', key: 'nickname' },
      { title: '球台', dataIndex: 'name', key: 'name' },
      { title: '购买时间', dataIndex: 'ctime', key: 'ctime' },
    ]

    const data = list.map((item) => {
      item.allsales = round(+item.allsale / 100, 2)
      item.cprices = +item.cprice / 100
      return item
    })
    const dataScale = []
    if (scaleList) {
      scaleList.forEach((v) => {
        v.detail.forEach((u) => {
          let x = JSON.parse(JSON.stringify(u))
          x.price_sale = +x.price_sale / 100
          x.amount_sale = +x.amount_sale / 100
          dataScale.push({
            commodity_name: v.commodity_name,
            type_name: v.type_name,
            ...x,
          })
        })
      })
    }

    let reportName = sessionStorage.getItem('reportName')
    let reportName2 = sessionStorage.getItem('reportName') + '-销售记录'
    if (period && period.start_time && period.end_time) {
      reportName += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
      reportName2 += `${changeStringTime(period.start_time)}-${changeStringTime(
        period.end_time
      )}`
    }
    const incomeSum = sum ? sum : 0
    return (
      <div style={{ marginTop: '1rem' }}>
        <div
          style={{
            cursor: 'default',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '200px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Button style={{ backgroundColor: '#1AAD19' }}>
              <a
                id="test"
                href={clickDownload(columns, data)}
                download={`${reportName}.csv`}
                style={{ color: 'white' }}
              >
                导出
              </a>
            </Button>
            <Button style={{ backgroundColor: '#1AAD19' }}>
              <a
                id="test"
                href={clickDownload(columnsScale, dataScale)}
                download={`${reportName2}.csv`}
                style={{ color: 'white' }}
              >
                导出销售记录
              </a>
            </Button>
          </div>
          <Button type="primary" ghost onClick={() => copyToClip(incomeSum)}>
            实收合计:￥{changeToDecimal(+incomeSum / 100)}元
          </Button>
        </div>
        <Table
          rowKey="id"
          bordered
          columns={columns}
          dataSource={data}
          size="middle"
        />
        {this.state.visible && (
          <ModalRecord
            {...this.state}
            marketRecord={marketRecord}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubMarket/component/report.js